import { createContext } from 'react'

export const UserSummaryContext = createContext(null)
